package com.artvending.warden.screens.sending

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.artvending.warden.Page
import com.artvending.warden.ScreenModel
import com.artvending.warden.currentScreenModel
import com.artvending.warden.screens.scanner.ScannerScreenModel

class SendingScreenModel : ScreenModel() {
	override val page: Page?
		get() = null
	
	
	@Composable
	override fun Display(scope: Any?) {
		scope.SendingScreen(this)
	}
	
	
	fun reset() {
		currentScreenModel = ScannerScreenModel()
	}
}


@Composable
expect fun Any?.SendingScreen(model: SendingScreenModel)